import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useIconGroupSectionStyles = makeStyles({
  iconGroupTitle: {
    ...shorthands.margin(
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalSNudge,
      tokens.spacingHorizontalNone,
    ),
  },
  iconGroup: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
    minWidth: '95px',
    flex: 1,
  },
});
